import axios from './axiosConfig';

const API_URL = '/players/';


const getAllPlayers = () => { // OK
    return axios.get(API_URL + 'all');
};

const togglePlayerStatus = async (userId) => { // OK
    return await axios.post(API_URL + 'toggle-player/' + userId);
};

const deletePlayer = async (playerId) => { // OK
    return await axios.delete(API_URL + playerId);
};

const getPlayerByUserId = async (userId) => {
    return await axios.get(API_URL + 'player/' + userId);
};

const getPlayersWithPlayedGames = (stageId) => {
    return axios.get(API_URL + 'played-games/' + stageId);
};

const applyPenalty = async (playerIds) => {
    return axios.put(API_URL + 'penalidades', {playerIds});
};

const updateAverage = async (data) => {
    return axios.put(API_URL + 'update-average', data)
}

export default {
    getAllPlayers,
    togglePlayerStatus,
    deletePlayer,
    getPlayerByUserId,
    getPlayersWithPlayedGames,
    applyPenalty,
    updateAverage,
};